import React from "react";
import styled from "styled-components";
import { theme } from "./theme";
import ProductCard from "./ProductCard";
import { useProducts } from "../hooks/useProducts";

export default function ProductsSection() {
  const { products, loading } = useProducts();

  return (
    <Section id="products">
      <Header>
        <Eyebrow>Produktet Tona</Eyebrow>
        <Headline>
          Shots organikë
          <br />
          <em>për çdo qëllim</em>
        </Headline>
        <Sub>100% natyralë. Të shtypur të ftohtë. Pa konservantë.</Sub>
      </Header>

      {loading ? (
        <LoadingRow>
          {[1, 2, 3].map((i) => (
            <SkeletonCard key={i} />
          ))}
        </LoadingRow>
      ) : products.length === 0 ? (
        <Empty>
          Nuk ka produkte aktualisht. Kontrolloni sërisht së shpejti.
        </Empty>
      ) : (
        <Grid>
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </Grid>
      )}
    </Section>
  );
}

const Section = styled.section`
  background: ${theme.colors.bg};
  padding: 6rem 5vw;
`;
const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;
const Eyebrow = styled.p`
  font-family: ${theme.fonts.mono};
  font-size: 0.7rem;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: ${theme.colors.textMuted};
  margin-bottom: 1rem;
`;
const Headline = styled.h2`
  font-family: "Playfair Display", serif;
  font-size: clamp(2rem, 5vw, 3.5rem);
  color: ${theme.colors.textPrimary};
  font-weight: 500;
  line-height: 1.15;
  margin: 0 0 1rem;
  em {
    color: #89d146;
    font-style: italic;
  }
`;
const Sub = styled.p`
  font-size: 0.9rem;
  color: ${theme.colors.textSecondary};
  line-height: 1.7;
`;
const Grid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2em;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  @media (max-width: 520px) {
    gap: 10px;
  }
`;
const LoadingRow = styled.div`
  display: grid;
  /* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;
const SkeletonCard = styled.div`
  height: 380px;
  border-radius: ${theme.radius.lg};
  background: linear-gradient(
    90deg,
    ${theme.colors.bgCard} 25%,
    ${theme.colors.bgSurface} 50%,
    ${theme.colors.bgCard} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
const Empty = styled.p`
  text-align: center;
  color: ${theme.colors.textMuted};
  font-size: 1rem;
  padding: 4rem;
`;
